import camelCase from 'lodash/camelCase';

import { UTM_TERMS } from '@app/common/constants';
import { IUtmObject } from '@app/common/interfaces';

type TGetUtmObjectFromUrl = (search: string) => IUtmObject;
type TCheckUtmLocalStorage = () => boolean;
type TRemoveUtmFromLocalStorage = () => void;
type TCheckAndSetLocalStorage = (search: string) => void;

// given the search params, this function will return the UTM object needed to store into local storage
export const getUtmObjectFromUrl: TGetUtmObjectFromUrl = (search: string): IUtmObject => {
  // example url '?utm_medium=valueToBeStored&utm_source=google&utm_campaign=developers';
  const result: IUtmObject = {};
  const terms: Set<string> = new Set<string>(UTM_TERMS);
  const searchParams = new URLSearchParams(search);

  searchParams.forEach((value, key) => {
    const urlKey: keyof IUtmObject = camelCase(decodeURIComponent(key)) as keyof IUtmObject;
    if (terms.has(urlKey)) {
      result[urlKey] = camelCase(decodeURIComponent(value));
    }
  });

  return result;
};

// checks local storage if any of the utm terms exist as keys
export const checkUtmLocalStorage: TCheckUtmLocalStorage = (): boolean => {
  return UTM_TERMS.some((term: string): boolean => {
    return localStorage.hasOwnProperty(term);
  });
};

export const removeUtmFromLocalStorage: TRemoveUtmFromLocalStorage = (): void => {
  localStorage.removeItem('utmMedium');
  localStorage.removeItem('utmSource');
  localStorage.removeItem('utmContent');
  localStorage.removeItem('utmCampaign');
  localStorage.removeItem('utmTerm');
};

export const checkAndSetLocalStorage: TCheckAndSetLocalStorage = (search: string): void => {
  // return early if the search parameters is empty
  if (!search) return;

  // remove all the old utmParameters if the utm items already exist in local storage
  if (checkUtmLocalStorage()) {
    removeUtmFromLocalStorage();
  }

  const utmObject: IUtmObject = getUtmObjectFromUrl(search);
  // iterate through the object and set the key and value into the local storage
  for (const [utmKey, utmValue] of Object.entries(utmObject)) {
    localStorage.setItem(utmKey, utmValue);
  }
};
